export class Subject {
    static idgen = 0;
    subscribers;
    _unsubscribeFromParent = undefined;
    _previousValue = undefined;
    equalityCompareFn = (newValue, oldValue) => newValue === oldValue;
    constructor(config) {
        this.subscribers = [];
        if (config?.equalityCompareFn) {
            this.equalityCompareFn = config.equalityCompareFn;
        }
    }
    _next(value) {
        if (!this.equalityCompareFn(value, this._previousValue)) {
            this.subscribers.forEach((s) => s.notify(value));
        }
        this._previousValue = value;
    }
    next = (value) => {
        this._next(value);
    };
    _subscribe(notify) {
        const sub = {
            id: Subject.idgen++,
            notify,
        };
        this.subscribers.push(sub);
        return () => this.unsubscribe(sub);
    }
    subscribe = (notify) => {
        return this._subscribe(notify);
    };
    pipe = (processFn) => {
        const subj = new Subject();
        subj._unsubscribeFromParent = this.subscribe((event) => {
            const processedEvent = processFn(event, this._previousValue);
            if (processedEvent.stopPropagation) {
                return;
            }
            else {
                subj.next(processedEvent.value);
            }
        });
        return subj;
    };
    unsubscribe(sub) {
        const index = this.subscribers.indexOf(sub);
        if (index > 0) {
            this.subscribers.splice(index, 1);
        }
    }
}
export class BehaviorSubject extends Subject {
    _value;
    constructor(initialValue, config) {
        super(config);
        this._value = initialValue;
        this._previousValue = initialValue;
    }
    get value() {
        return this._value;
    }
    next = (value) => {
        this._value = value;
        this._next(value);
    };
    subscribe = (notify) => {
        notify(this._value);
        return this._subscribe(notify);
    };
    pipe = (processFn) => {
        const defaultValue = processFn(this._value, undefined);
        const subj = defaultValue.stopPropagation
            ? new Subject()
            : new BehaviorSubject(defaultValue.value);
        subj._unsubscribeFromParent = this.subscribe((event) => {
            const processedEvent = processFn(event, this._previousValue);
            if (processedEvent.stopPropagation) {
                return;
            }
            else {
                subj.next(processedEvent.value);
            }
        });
        return subj;
    };
}
export function filter(predicate) {
    return (value) => ({
        value: value,
        stopPropagation: !predicate(value),
    });
}
/**
 * Skips emitted values from source until provided expression is false.
 *
 * @param {booleanPredicateFn} predicate The predicate expression used for skipping emitted values.
 */
export function skipWhile(predicate) {
    return (newValue, oldValue) => ({
        value: newValue,
        stopPropagation: predicate(newValue, oldValue),
    });
}
